export enum PopupType {
    Btn = 'btn',
    Chat = 'chat',
}